export default function IntegrationIcon({ video }: any) {
  let href = "";
  let icon = "icon";
  let alt = "alt";
  let rounded = true;

  if (video.integration_slug === "wikipedia") {
    href = `https://en.wikipedia.org/?curid=${video.integration_object_id}`;
    icon =
      "https://upload.wikimedia.org/wikipedia/en/thumb/8/80/Wikipedia-logo-v2.svg/206px-Wikipedia-logo-v2.svg.png?20111003033239";
    alt = "Wikipedia Logo";
  }

  if (video.integration_slug === "artic") {
    href = `https://www.artic.edu/artworks/${video.integration_object_id}`;
    icon = "/sources/artic.png";
    alt = "The Art Institute of Chicago Logo";
    rounded = false;
  }

  if (video.integration_slug === "tate") {
    href = `https://www.tate.org.uk/artworks/${video.integration_object_id}`;
    icon = "/sources/tate.png";
    alt = "Tate Modern";
    rounded = true;
  }

  if (video.integration_slug === "metmuseum") {
    console.log("====================================");
    console.log(video);
    rounded = false;
    icon = "/sources/logo_the_met.png";
    alt = "The Met Museum Logo";
    href = `https://www.metmuseum.org/art/collection/search/${video.integration_object_id}`;
  }

  if (video.integration_slug === "prelinger") {
    rounded = false;
    icon = "/sources/prelinger.gif";
    alt = "The Prelinger Archive Logo";
    href = `https://archive.org/details/${video.integration_object_id}`;
  }

  if (video.integration_slug === "clevelandart") {
    rounded = false;
    icon = "/sources/clevelandart.png";
    alt = "The Cleveland Art Museum Logo";
    href = `https://clevelandart.org/art/${video.integration_object_id}`;
  }

  if (video.link_url) {
    href = video.link_url;
  }

  // TODO: Fix links to museum websites. They're not working.
  return (
    <span>
      {icon ? (
        <img
          className={rounded ? "mr-4 w-8 h-8 rounded-full" : "mr-4 w-8 h-8"}
          src={icon}
          alt={alt}
        />
      ) : (
        <span>{video.integration_slug.toUpperCase()}</span>
      )}
    </span>
  );


  // return (
  //     <a href={href} target="_blank" rel="noreferrer">
  //       <img
  //         className={rounded ? "mr-4 w-8 h-8 rounded-full" : "mr-4 w-8 h-8"}
  //         src={icon}
  //         alt={alt}
  //       />
  //     </a>
  // );
}
